import React, { useEffect, useState } from 'react';
import { useUser } from 'hooks';
import PropsTypes from 'prop-types';
import { ENABLED_DETECT_PERMISSION } from 'config';

const PermissionWrapper = (props) => {
  const { permissions, children, msgNoPermission } = props;
  const [hasPermission, setHasPermission] = useState(true);
  const user = useUser();
  // if (!user?._id)
  //   return null;
  useEffect(() => {
    if (ENABLED_DETECT_PERMISSION) {
      if (permissions?.length) {
        let check = false;
        permissions?.map((item) => {
          if (
            user?.userType?.indexOf(
              item?.[2]
                ? `"method":"${item?.[0]?.toUpperCase()}","route":"${
                    item?.[1]
                  }","role":"${item?.[2]}"`
                : `"method":"${item?.[0]?.toUpperCase()}","route":"${
                    item?.[1]
                  }"`,
            ) !== -1
          ) {
            check = true;
          }
        });
        setHasPermission(check);
      }
    }
  }, [user?.userType]);

  if (!hasPermission) {
    if (msgNoPermission) {
      return <div className="text-center m-2">{msgNoPermission}</div>;
    }
    return null;
  }

  return <>{children}</>;
};

PermissionWrapper.prototype = {
  permissions: PropsTypes.any,
  children: PropsTypes.any.isRequired,
  msgNoPermission: PropsTypes.any,
};

export default PermissionWrapper;
